import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import About from '../components/About';
import Career from '../components/Career';
import Content from '../components/Content';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

function HomePage() {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Handle scrolling after navigation from other pages
  useEffect(() => {
    if (location.state && (location.state as any).scrollTo) {
      const hash = (location.state as any).scrollTo;
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      // Clear the state to prevent scrolling on every render
      window.history.replaceState({}, '', location.pathname);
    }
  }, [location]);

  return (
    <div className="App">
      <Header />
      <Hero isVisible={isVisible} />
      <Stats isVisible={isVisible} />
      <About />
      <Career />
      <Testimonials />
      <Content />
      <Contact />
      <Footer />
    </div>
  );
}

export default HomePage;

